exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-icon-device[data-v-76743e9f] {\n  width: 4rem;\n}\n.table-icon-device .icon-device[data-v-76743e9f] {\n  stroke: rgb(184, 184, 184);\n}\n.table-icon-device path[data-v-76743e9f] {\n  fill: rgb(134, 134, 134);\n}\n", ""]);

// exports
